module.exports = __webpack_public_path__ + "img/1139753939.deee1f45.jpg";